import cookie from 'js-cookie'
import skipManager from './skipManager'
import axios from "@/api/axios";

export function getsec(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 === "s") {
        return str1 * 1000;
    } else if (str2 === "h") {
        return str1 * 60 * 60 * 1000;
    } else if (str2 === "d") {
        return str1 * 24 * 60 * 60 * 1000;
    }
}

export function isIphoneX() {
    return /iphone/gi.test(navigator.userAgent) && (window.screen.height >= 812 && window.screen.width >= 375)
        // return navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && window.screen.height === 812 && window.screen.width === 375
}
export const getIsIphoneX = function() {
        return /iphone/gi.test(navigator.userAgent) && (window.screen.height >= 812 && window.screen.width >= 375)
    }()
    //正则表达式验证
export function regExp(target, fmt) {
    return fmt.test(target)
}
export function regExpVerifyCode(code) {
    return regExp(code, /\d{6}$/)
}

export function regExpBankCode(code) {
    return regExp(code, /^([1-9]{1})(\d{14}|\d{15}|\d{16}|\d{17}|\d{18})$/)
}

export function regExpMoneyNum(pNum) {
    return regExp(pNum, /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/)
}
export const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
export const formatNumber = n => {
        n = n.toString()
        return n[1] ? n : '0' + n
    }
    //整数位补零
export const prefixZero = (num = 0, n = 2) => {
    //非法情况处理
    if (isNaN(Number(num))) {
        return "--";
    }
    //整数长度大于n处理
    if (parseInt(num, 10).toString().length >= n) {
        return num;
    }
    //小数情况处理
    let arr = String(num).split(".");
    let l = arr.length === 2 ? arr[1].length + 1 : 0;

    return (Array(n).join("0") + num).slice(-(n + l));
};

const isIpPort = (str) => {
    if (typeof str === 'string') {
        let arr1 = str.split(':')
        if (arr1.length === 2) {
            let ip = arr1[0]
            let arr = ip.split('.')
            if (arr.length === 4) {
                for (let i in arr) {
                    if (isNaN(parseInt(arr[i], 10))) {
                        return {
                            is: false,
                            ip: ''
                        }
                    }
                }
                return {
                    is: true,
                    ip: ip
                }
            }
        }
    }
    return {
        is: false,
        ip: ''
    }
}

export const getDomain = () => {
    let href = window.location.href
    try {
        href = href.replace('http://', '').replace('https://', '')
        href = href.split('/')[0]
        let res = isIpPort(href)
        if (res.is) {
            return res.ip
        }
        let splited = href.split('.')
        href = splited.splice(1, splited.length - 1).join('.')
        return href
    } catch (error) {
        return href
    }
}

export const cookieSet = (key, value, expires = 30) => {
    if (key) {
        cookie.set(`${key}`, value, {
            domain: getDomain(),
            expires: expires
        })
    }
}

export const cookieGet = (key) => {
    let t = ''
    if (key) {
        t = cookie.get(`${key}`)
    }
    return t
}

export const getIsWxWebEnv = function() {
        let ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') !== -1;
    }()
    /*
     * @desc 是否在微信公众号环境内
     * @return [Boolean]
     * */
export const isWxWebEnv = () => {
    let ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
}

export const timeStamp2hm = (timeStamp) => {
    let date = new Date(timeStamp);
    return `${prefixZero(date.getHours())}:${prefixZero(date.getMinutes())}`;
};

let floatObj = function() {

    /*
     * 判断obj是否为一个整数
     */
    function isInteger(obj) {
        return Math.floor(obj) === obj
    }

    /*
     * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
     * @param floatNum {number} 小数
     * @return {object}
     *   {times:100, num: 314}
     */
    const toInteger = function(floatNum) {
        var ret = { times: 1, num: 0 }
        var isNegative = floatNum < 0
        if (isInteger(floatNum)) {
            ret.num = floatNum
            return ret
        }
        var strfi = floatNum + ''
        var dotPos = strfi.indexOf('.')
        var len = strfi.substr(dotPos + 1).length
        var times = Math.pow(10, len)
        var intNum = parseInt(Math.abs(floatNum) * times + 0.5, 10)
        ret.times = times
        if (isNegative) {
            intNum = -intNum
        }
        ret.num = intNum
        return ret
    }

    /*
     * 核心方法，实现加减乘除运算，确保不丢失精度
     * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
     *
     * @param a {number} 运算数1
     * @param b {number} 运算数2
     * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
     * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
     *
     */
    const operation = function(a, b, digits, op) {
        var o1 = toInteger(a)
        var o2 = toInteger(b)
        var n1 = o1.num
        var n2 = o2.num
        var t1 = o1.times
        var t2 = o2.times
        var max = t1 > t2 ? t1 : t2
        var result = null
        switch (op) {
            case 'add':
                if (t1 === t2) { // 两个小数位数相同
                    result = n1 + n2
                } else if (t1 > t2) { // o1 小数位 大于 o2
                    result = n1 + n2 * (t1 / t2)
                } else { // o1 小数位 小于 o2
                    result = n1 * (t2 / t1) + n2
                }
                return result / max
            case 'subtract':
                if (t1 === t2) {
                    result = n1 - n2
                } else if (t1 > t2) {
                    result = n1 - n2 * (t1 / t2)
                } else {
                    result = n1 * (t2 / t1) - n2
                }
                return result / max
            case 'multiply':
                result = (n1 * n2) / (t1 * t2)
                return result
            case 'divide':
                result = (n1 / n2) * (t2 / t1)
                return result
        }
    }

    // 加减乘除的四个接口
    const add = function(a, b, digits) {
        return operation(a, b, digits, 'add')
    }

    const subtract = function(a, b, digits) {
        return operation(a, b, digits, 'subtract')
    }

    const multiply = function(a, b, digits) {
        return operation(a, b, digits, 'multiply')
    }

    const divide = function(a, b, digits) {
        return operation(a, b, digits, 'divide')
    }

    // exports
    return {
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide
    }
}();

const formatImgUrl = function(url, type, param1, param2) {
    console.log(url)
    let str = `${url.split("?")[0]}?imageView2/${type}${param1 ? '/w/' + param1 : ''}${param2 ? '/h/' + param2 : ''}`
    let scaledWidthLimitImage = JSON.parse(localStorage.CDNFormat).scaledWidthLimitImage
    if (scaledWidthLimitImage) {
        let strFlag = scaledWidthLimitImage
        let arr = strFlag.split('<width>')
        str = `${url ? url.split('?')[0] : ''}${arr[0]}${param1}${arr[1]}`
    }
    return str.trim()
}
const formatSquaredImgUrl = function(url, type, param1, param2) {
    let str = `${url.split("?")[0]}?imageView2/${type}${param1 ? '/w/' + param1 : ''}${param2 ? '/q/' + param2 : ''}`
    if (localStorage.CDNFormat.squaredImage) {
        let strFlag = localStorage.CDNFormat.squaredImage
        let arr = strFlag.split('<width>')
        str = `${url ? url.split('?')[0] : ''}${arr[0]}${param1}${arr[1]}`
    }
    return str
}

// 时间格式化 yyyy-MM-dd hh:mm:ss 可自定义时间格式
const formatTime2 = function(date, format) {
    date = new Date(date)
    var map = {
        "M": date.getMonth() + 1, //月份
        "d": date.getDate(), //日
        "h": date.getHours(), //小时
        "m": date.getMinutes(), //分
        "s": date.getSeconds(), //秒
        "q": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    }

    format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
        var v = map[t]
        if (v !== undefined) {
            if (all.length > 1) {
                v = '0' + v
                v = v.substr(v.length - 2)
            }
            return v
        } else if (t === 'y') {
            return (date.getFullYear() + '').substr(4 - all.length)
        }
        return all
    })
    return format
}

/**
 * 获取指定的URL参数值
 * URL:mryt://mryt.com/home/home?sku=weww-ww
 * 参数：paramName URL参数
 * 调用方法:getQueryString(URL)
 * 返回值:{model: index, view: index, options:[{name: sku, value: weww-ww}]}
 */
function getQueryString(URL, fs) {
    let Url = {}
    let QSURL = URL
    let QSURLNUM = QSURL.indexOf("//");
    let num = URL.indexOf("?")
    if (num >= 0) {
        QSURL = URL.substr(0, num);
        let QSURLNUM = QSURL.indexOf("//");
    }

    QSURL = QSURL.substr(QSURLNUM + 2)
    let arr1 = QSURL.split("\/"); //各个参数放到数组里
    Url.model = arr1[1]
    Url.view = arr1[2]
    URL = URL.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
    var arr = URL.split("&"); //各个参数放到数组里
    Url.options = {
        fs: fs
    }
    for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
            Url.options[arr[i].substring(0, num)] = arr[i].substr(num + 1);
        }
    }
    return Url
}

const verifyUrl = (data, fs = 'banner', fn) => {
    if (regExp(data, /(http|https):\/\//)) {
        window.location.href = jointParam(data)
    } else if (regExp(data, /mryt:\/\//)) {
        skipManager.jumpPath(getQueryString(data, fs))
    } else {
        typeof fn === 'function' && fn(false)
    }

}

const jointParam = (link) => {
    let link_url = ''
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo')) || {}
    let buriedPoint = window.localStorage.getItem('buriedPoint') || {}
    if (link.includes('?') || link.includes('%3F')) {
        link_url = `${decodeURIComponent(link)}&source=web&accessToken=${encodeURIComponent(userInfo.accessToken)}&version=${axios.query.v}&userType=${userInfo.userType}&buriedPoint=${buriedPoint}&inviteCode=${userInfo.inviteCode}&userId=${userInfo.userId}&userLevel=${userInfo.userLevel}`
    } else {
        link_url = `${decodeURIComponent(link)}?source=web&accessToken=${encodeURIComponent(userInfo.accessToken)}&version=${axios.query.v}&userType=${userInfo.userType}&buriedPoint=${buriedPoint}&inviteCode=${userInfo.inviteCode}&userId=${userInfo.userId}&userLevel=${userInfo.userLevel}`
    }

    let inviteInfo = cookieGet('inviteInfo') || {}

    if (Object.keys(inviteInfo) && Object.keys(inviteInfo).length) {
        link_url = encodeURI(`${link_url}&rcinviteCode=${inviteInfo.inviteCode}`)
    } else {
        link_url = encodeURI(link_url)
    }
    return link_url
}
const goLogin = () => {
    let host = window.location.origin
    let pathname = window.location.pathname
    let search = window.location.search
    cookieSet('accessToken', '')
    location.href = `${host}/login?ret=${encodeURIComponent(pathname + (search ? search : ''))}`
}
const  isStrEmpty = (str) => {
    if (typeof(str) !== "string") {
        return true
    }
    return !str
}
const parseQuery = (query) => {
    var reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
    var obj = {};
    while (reg.exec(query)) {
        obj[RegExp.$1] = RegExp.$2;
    }
    return obj;
}
const formatCodeUrl = (url) => {
    if (isStrEmpty(url)) {
        return {}
    }
    url = decodeURIComponent(url)
    try {
        let params = url.split("?")[1]
        let qrcodeParams = parseQuery(params)
        return qrcodeParams
    } catch (err) {
        console.error(err)
        return {}
    }
}
export default {
    isIphoneX: isIphoneX,
    regExpVerifyCode: regExpVerifyCode,
    regExpBankCode: regExpBankCode,
    regExpMoneyNum: regExpMoneyNum,
    formatTime: formatTime,
    prefixZero: prefixZero,
    cookieSet: cookieSet,
    cookieGet: cookieGet,
    isWxWebEnv: isWxWebEnv,
    timeStamp2hm: timeStamp2hm,
    floatObj: floatObj,
    formatSquaredImgUrl: formatSquaredImgUrl,
    formatImgUrl: formatImgUrl,
    formatTime2: formatTime2,
    verifyUrl: verifyUrl,
    jointParam: jointParam,
    goLogin: goLogin,
    formatCodeUrl: formatCodeUrl
}



// WEBPACK FOOTER //
// ./src/utils/util.js